<template>
    <div class="page-outer">
        <transition name="page" mode="out-in" appear>
            <slot />
        </transition>
    </div>
</template>
